import { ReactNode } from "react";

interface Props {
  title: string;
  description?: string;
  subtitle?: string;
  action?: ReactNode;
  children?: ReactNode;
}

export function PageHeader({ title, description, subtitle, action, children }: Props) {
  const desc = description || subtitle;
  const actions = action || children;

  return (
    <div className="flex flex-col gap-3 border-b bg-card px-4 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-6">
      <div>
        <h1 className="text-xl font-semibold tracking-tight text-foreground sm:text-2xl">{title}</h1>
        {desc && <p className="mt-1 text-sm text-muted-foreground">{desc}</p>}
      </div>
      {actions && <div className="flex flex-wrap shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
